import React, { FC } from "react"
import { Box, Divider, Typography } from "@strapi/design-system"
import { X } from "lucide-react"

interface ModalProps {
  isOpen: boolean
  onClose?: () => void
  showCloseButton?: boolean
  title: string
  startTitleIcon?: React.ReactNode
  children: React.ReactNode
  width?: number | string
  closeOnBackgroundClick?: boolean
}

export const CustomModal: FC<ModalProps> = ({
  isOpen,
  closeOnBackgroundClick = true,
  onClose,
  showCloseButton = true,
  title,
  startTitleIcon,
  children,
  width = "560px",
}) => {
  if (!isOpen) return null

  const handleBackgroundClick = () => {
    if (onClose) onClose()
  }

  return (
    <Box
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20,
      }}
      onClick={() => closeOnBackgroundClick && handleBackgroundClick()}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        background="neutral0"
        style={{
          width,
          maxWidth: "90%",
          minWidth: width,
          padding: "10px 20px 20px 20px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: `${startTitleIcon ? "0" : "5px"} 0 ${startTitleIcon ? "0" : "5px"} 0`,
            marginBottom: "10px",
          }}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {startTitleIcon && (
              <Box style={{ width: "32px", height: "32px" }}>{startTitleIcon}</Box>
            )}
            <Typography variant="beta">{title}</Typography>
          </Box>
          {showCloseButton && <X onClick={onClose} color={"white"} style={{ cursor: "pointer" }} />}
        </Box>
        <Divider style={{ width }} />
        <Box
          style={{
            padding: "20px 0",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
